import { HeartFilled, HeartOutlined } from "@ant-design/icons";
import { opacify } from "polished";
import styled from "styled-components";

export interface BusinessAddToFavoritesButtonProps {
  isFavorite: boolean;
  onClick: (isFavorite: boolean) => void;
}

export const FavotiteIcon = styled(HeartFilled)(({ theme }) => ({
  fontSize: 24,
  cursor: "pointer",
  color: theme.colorPrimary,

  "&:hover": {
    color: opacify(0.8, theme.colorPrimary),
  },
}));

export const FavotiteBorderIcon = styled(HeartOutlined)(({ theme }) => ({
  fontSize: 24,
  cursor: "pointer",
  color: "rgba(0,0,0,0.45)",

  "&:hover": {
    color: theme.colorPrimary,
  },
}));
